<template>
  <b-button
    :class="{ 'btn-icon rounded-circle': iconOnly }"
    v-bind="$attrs"
    v-on="$listeners"
    :disabled="loading"
    :type="type"
  >
    <div v-if="loading" class="row align-items-center">
      <b-spinner class="mx-50" small />
      <span v-if="!iconOnly">
        {{ loadingLabel }}
      </span>
    </div>

    <div v-else>
      <feather-icon
        v-if="!noIcon"
        :icon="icon"
        :class="{ 'mr-50': !iconOnly }"
      />
      <span v-if="!iconOnly">{{ label }}</span>
    </div>
  </b-button>
</template>

<script>
import { BButton, BSpinner } from "bootstrap-vue";
export default {
  components: {
    BButton,
    BSpinner,
  },
  props: {
    loading: {
      type: Boolean,
      default: () => false,
    },
    noIcon: {
      type: Boolean,
      default: () => false,
    },
    loadingLabel: {
      type: String,
      default: () => "جاري الحفظ",
    },
    label: {
      type: String,
      default: () => "حفظ",
    },
    type: {
      type: String,
    },
    icon: {
      type: String,
      default: () => "SaveIcon",
    },
    iconOnly: {
      type: Boolean,
      default: () => false,
    },
  },
};
</script>
